import styled from 'styled-components';

const Company = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 8px;
  width: ${props => Math.floor(100/props.size) }%;

  span {
    font-size: 7pt;
  }
`

const ProductionCompany = ({  name, address1, address2, city, stateProv, zipCode, length }) => {
  return(
    <Company size={length} >
      <p><b>{name.toUpperCase()}</b><br/>
      <span>{`${address1}${address1.length && address2.length ? ", " : ""}${address2}`}<br/>
      {`${city}${city.length && stateProv.length ? ", " : ""}${stateProv} ${zipCode}`}</span></p>
    </Company>
  )
}

export default ProductionCompany
